module.exports = __webpack_public_path__ + "372ba07cf697960fde0ec4f1aabc56ae.jpg";